import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type CheckCircleIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M14.6668 7.38666V7.99999C14.666 9.43761 14.2005 10.8364 13.3397 11.9879C12.4789 13.1393 11.269 13.9816 9.8904 14.3893C8.51178 14.7969 7.03834 14.7479 5.68981 14.2497C4.34128 13.7515 3.18993 12.8307 2.40747 11.6247C1.62501 10.4187 1.25336 8.99203 1.34795 7.55753C1.44254 6.12303 1.9983 4.75754 2.93235 3.66471C3.8664 2.57187 5.12869 1.81025 6.53096 1.49342C7.93322 1.1766 9.40034 1.32155 10.7135 1.90666',
    'M14.6667 2.66667L8 9.34L6 7.34',
  ],
  '24': [
    'M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18456 2.99721 7.13632 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24014C11.8996 1.76491 14.1003 1.98233 16.07 2.86',
    'M22 4L12 14.01L9 11.01',
  ],
  '32': [
    'M29.3332 14.7733V16C29.3315 18.8752 28.4005 21.6729 26.679 23.9758C24.9574 26.2786 22.5376 27.9633 19.7803 28.7785C17.0231 29.5938 14.0762 29.4959 11.3791 28.4994C8.68208 27.503 6.37938 25.6615 4.81445 23.2494C3.24953 20.8374 2.50623 17.9841 2.69541 15.1151C2.88459 12.2461 3.99611 9.5151 5.86421 7.32943C7.73231 5.14376 10.2569 3.62051 13.0614 2.98686C15.866 2.35321 18.8002 2.64312 21.4265 3.81333',
    'M29.3333 5.33334L16 18.68L12 14.68',
  ],
};

const CheckCircleIcon = (props: CheckCircleIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      <path
        d={paths[0]}
        stroke={colorOptions}
        strokeWidth={iconStrokeWidthBySize[size]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={paths[1]}
        stroke={colorOptions}
        strokeWidth={iconStrokeWidthBySize[size]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckCircleIcon;
